import * as React from 'react';
import { DateFormat, DateRangeInput as CoreDRI } from '@mc/react-datetime';
import { format, stringInputParseDate } from '@mc/react-datetime';
import { parseISO } from 'date-fns';

export type ValType = [string | null, string | null];
type CoreSinglVal = Date | null;
type CoreValType = [CoreSinglVal, CoreSinglVal];

type Props = Omit<
  React.ComponentProps<typeof CoreDRI>,
  'value' | 'parseDate' | 'formatDate' | 'onChange'
> & {
  onChange?: (value?: ValType) => void;
  onBlur?: (value?: ValType) => void;
  value?: ValType;
  disabled?: boolean;
};

export function getJavaDate(date?: CoreSinglVal) {
  if (!date) {
    return null;
  }

  const localDate = new Date(+date);
  localDate.setMinutes(localDate.getMinutes() + -localDate.getTimezoneOffset());
  return localDate.toISOString().split('T')[0];
}

export const StringDateRange: React.FC<Props> = ({
  value,
  popoverProps,
  onBlur,
  onChange,
  ...other
}) => {
  const parsedVal: CoreValType = [null, null];
  if (value) {
    parsedVal[0] = value[0] ? parseISO(value[0]) : null;
    parsedVal[1] = value[1] ? parseISO(value[1]) : null;
  }

  const onClose = React.useCallback(
    (e) => {
      popoverProps?.onClose?.(e);
      onBlur?.(value);
    },
    [popoverProps ? popoverProps.onClose : undefined, onBlur, value]
  );

  return (
    <CoreDRI
      onChange={([orStart, orEnd]: [CoreSinglVal, CoreSinglVal]) => {
        if (orStart === null && orEnd === null) {
        }
        const start = orStart !== null ? getJavaDate(orStart) : null;
        const end = orEnd !== null ? getJavaDate(orEnd) : null;
        onChange?.([start, end]);
      }}
      popoverProps={{
        ...(popoverProps || {}),
        onClose,
      }}
      formatDate={(date: Date) =>
        format(date, {
          dateFormat: DateFormat.LONG_SPACES,
        })
      }
      parseDate={stringInputParseDate}
      value={parsedVal}
      {...other}
    />
  );
};
